import { Card, CardContent, Container, Grid } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import React from 'react'

const Tim = () => {
    return (
        <Container sx={{ my: 10 }}>
            <ArgonBox mt={2}>
                <Grid container spacing={2} my={2}>
                    <Grid item xs={12} xl={12}>
                        <ArgonTypography>TIM</ArgonTypography>
                    </Grid>
                </Grid>
            </ArgonBox>
            <ArgonBox mt={2}>
                <Card>
                    <CardContent>
                        <Grid container spacing={2} mt={1}>
                            <Grid item xs={12} xl={12}>
                                <ArgonTypography>
                                    Sedang dalam Pembentukan Tim
                                </ArgonTypography>
                            </Grid>

                        </Grid>
                    </CardContent>
                </Card>
            </ArgonBox>
        </Container>
    )
}

export default Tim